import { useCreateAppointmentSchedulingLink } from '@/api/hooks/useCreateAppointmentSchedulingLink'
import { analytics } from '@/lib/analytics'
import { Button, ButtonText } from '@/ui/core/button'
import { router } from 'expo-router'
import { Platform } from 'react-native'
import Toast from 'react-native-toast-message'

const ScheduleAppointmentButton = () => {
	const { mutate: createSchedulingLink, isPending: isCreatingSchedulingLink } =
		useCreateAppointmentSchedulingLink()

	const onBookAppointmentClick = async () => {
		analytics.trackClick('scheduling-appointment-button')

		let schedulingWindow: Window | null = null

		if (Platform.OS === 'web') {
			schedulingWindow = window.open('about:blank', '_blank')
		}

		createSchedulingLink(undefined, {
			onSuccess: (response) => {
				const { schedulingURL } = response as { schedulingURL: string }
				const urlWithUtms = `${schedulingURL}&utm_source=patient_app`

				if (Platform.OS === 'web') {
					if (schedulingWindow && !schedulingWindow.closed) {
						schedulingWindow.location.href = urlWithUtms
					} else {
						window.open(urlWithUtms, '_blank')
					}
				} else {
					router.push({
						pathname: '/schedule-appointment',
						params: {
							scheduleUrl: urlWithUtms,
						},
					})
				}
			},
			onError: () => {
				if (schedulingWindow && !schedulingWindow.closed) {
					schedulingWindow.close()
				}
				Toast.show({
					type: 'error',
					text1: 'Unable to open scheduling',
					text2: 'Please try again later',
					position: 'bottom',
				})
			},
		})
	}

	return (
		<Button
			isLoading={isCreatingSchedulingLink}
			onPress={onBookAppointmentClick}
			className="max-w-64"
		>
			<ButtonText>Book An Appointment</ButtonText>
		</Button>
	)
}

export { ScheduleAppointmentButton }
